<template>
  <vue-content-loading :height="containerHeight" :width="containerWidth">
    <rect
      v-for="(cardDimension, index) in cardDimensions"
      :key="`card_${index}`"
      v-bind="cardDimension" />
  </vue-content-loading>
</template>

<script>
import VueContentLoading from 'vue-content-loading';

export default {
  components: {
    VueContentLoading,
  },
  data() {
    return {
      containerHeight: 300,
      containerWidth: 300,
      cardCount: 4,
      cardsPerRow: 2,
      cardHeight: 135,
      cardWidth: 135,
    };
  },
  computed: {
    cardDimensions() {
      const output = [];
      let cardRow = 0;

      for (let i = 0; i < this.cardCount; i += 1) {
        const cardObject = {
          x: i % 2 && i > 0 ? 150 : 8,
          y: (this.cardHeight + 10) * cardRow,
          rx: 2,
          ry: 2,
          height: this.cardHeight,
          width: this.cardWidth,
        };

        if (i % 2 && i > 0) {
          cardRow += 1;
        }

        if (this.$vuetify.breakpoint.mdAndDown) {
          const mobileCardHeight = this.cardHeight / 2;
          cardObject.x = 0;
          cardObject.y = i * (mobileCardHeight + 5);
          cardObject.height = mobileCardHeight;
          cardObject.width = this.containerWidth;
        }

        output.push(cardObject);
      }
      return output;
    },
  },
};
</script>
